import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, Save, Loader2, ScrollText } from "lucide-react";
import api, { apiErr } from "@/lib/api";

const letters = "abcdefghijklmnopqrstuvwxyz";

export default function ConsideracionesDefaults() {
  const [items, setItems] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings/consideraciones").then((r) => setItems(r.data.items)).catch((e) => toast.error(apiErr(e)));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/settings/consideraciones", { items });
      setItems(data.items);
      toast.success("Consideraciones guardadas para nuevas cotizaciones");
    } catch (e) { toast.error(apiErr(e)); } finally { setSaving(false); }
  };

  return (
    <div className="bg-white border border-slate-200 rounded-lg overflow-hidden" data-testid="default-clauses-card">
      <div className="flex items-center justify-between px-5 py-4 border-b border-slate-200">
        <div>
          <h3 className="font-display font-bold text-slate-900 text-sm uppercase tracking-wide flex items-center gap-2">
            <ScrollText className="h-4 w-4 text-slate-500" /> Consideraciones comerciales
          </h3>
          <p className="text-xs text-slate-500 mt-0.5">Se copian a las cotizaciones que se creen a partir de ahora. Las cotizaciones existentes no cambian.</p>
        </div>
        <button data-testid="default-clauses-save" onClick={save} disabled={saving || !items}
          className="flex items-center gap-1.5 text-sm bg-slate-900 hover:bg-slate-800 text-white font-semibold px-4 py-2 rounded-md transition-colors disabled:opacity-50">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Guardar consideraciones
        </button>
      </div>
      <div className="p-5 space-y-2">
        {!items ? <div className="text-slate-400 text-sm flex items-center gap-2"><Loader2 className="h-4 w-4 animate-spin" /> Cargando...</div> : items.map((c, i) => (
          <div key={i} className="flex gap-2 items-start">
            <span className="font-mono text-xs text-slate-400 w-5 pt-2.5">{letters[i] || i + 1}.</span>
            <textarea data-testid={`default-clause-input-${i}`} rows={2} value={c}
              onChange={(e) => setItems(items.map((x, j) => (j === i ? e.target.value : x)))}
              className="flex-1 px-3 py-2 rounded-md border border-slate-200 focus:outline-none focus:ring-2 focus:ring-emerald-500 text-sm resize-y" />
            <button data-testid={`default-clause-del-${i}`} onClick={() => setItems(items.filter((_, j) => j !== i))}
              className="text-slate-300 hover:text-red-500 pt-2.5 transition-colors"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
        {items && (
          <button data-testid="default-clause-add" onClick={() => setItems([...items, ""])}
            className="flex items-center gap-1.5 text-sm text-emerald-600 hover:text-emerald-700 font-medium pt-1">
            <Plus className="h-4 w-4" /> Agregar cláusula
          </button>
        )}
      </div>
    </div>
  );
}
